var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "140 70.01 396.67 396.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m163.33 426.84 333.5-333.5h-333.5zm350-317-333.5 333.5h333.5zm-361.66 356.84c-6.4453 0-11.668-5.2266-11.668-11.668v-373.33c0-6.4453 5.2227-11.668 11.668-11.668h373.33c6.4414 0 11.668 5.2227 11.668 11.668v373.33c0 6.4414-5.2266 11.668-11.668 11.668z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissing);
export default __webpack_public_path__ + "static/media/icon-missing.31850a715c5be10843e8e3021b386c7a.svg";
export { ForwardRef as ReactComponent };